import * as React from "react";
const SvgFiRrLinkSlashAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-link-slash-alt_svg__a)">
      <path
        fill="#062147"
        d="M11.953 17.993a6.23 6.23 0 0 1-4.12-1.823 6.5 6.5 0 0 1-.642-.748 1 1 0 0 1 1.617-1.178q.194.268.437.511a4.23 4.23 0 0 0 2.802 1.24 1 1 0 0 1-.046 2zM1.831 13.331a6.2 6.2 0 0 0-1.83 4.42c0 1.668.65 3.238 1.83 4.418A6.2 6.2 0 0 0 6.251 24c1.67 0 3.238-.65 4.418-1.83l1.058-1.059a.999.999 0 1 0-1.414-1.414l-1.058 1.058A4.22 4.22 0 0 1 6.25 22a4.22 4.22 0 0 1-3.005-1.245A4.22 4.22 0 0 1 2 17.75a4.22 4.22 0 0 1 1.245-3.005l3.037-3.038a.999.999 0 1 0-1.414-1.414zM.293 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-6.58-6.58 5.042-5.044A6.2 6.2 0 0 0 24 6.25c0-1.669-.65-3.239-1.83-4.419a6.2 6.2 0 0 0-4.42-1.83c-1.67 0-3.239.65-4.419 1.83L12.273 2.89a.999.999 0 1 0 1.414 1.414l1.058-1.058A4.22 4.22 0 0 1 17.75 2c1.135 0 2.202.442 3.005 1.245A4.22 4.22 0 0 1 22 6.25a4.22 4.22 0 0 1-1.245 3.005l-5.043 5.043L9.86 8.446a4.22 4.22 0 0 1 4.894.798q.243.244.437.511a1 1 0 0 0 1.398.22 1 1 0 0 0 .22-1.398 6 6 0 0 0-.64-.748c-2.096-2.095-5.298-2.408-7.76-.835L1.706.294A.999.999 0 1 0 .293 1.706"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-link-slash-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLinkSlashAlt;
